/**
 * logger — centralized client-side logging.
 *
 * Purpose: one seam for all console output so it can later be wired to a
 * remote sink (Sentry/LogRocket) without touching call sites.
 * Flow: errors always surface (they matter in prod); warn/info are dev-only
 * to keep the production console clean.
 */
const isDev = import.meta.env.DEV;

export const logger = {
  /** Always logged — genuine failures. Wire a remote sink here when added. */
  error(...args: unknown[]): void {
    console.error(...args);
  },
  /** Dev-only — non-fatal anomalies. */
  warn(...args: unknown[]): void {
    if (isDev) console.warn(...args);
  },
  /** Dev-only — diagnostic breadcrumbs. */
  info(...args: unknown[]): void {
    if (isDev) console.info(...args);
  },
} as const;
